/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Модель доставки товаров из корзины.
   * @constructor
   */
  app.CartItemDelivery = app.ItemPageableCollection.extend({
    url: app.entryScriptName + '/api/v4/cart-item-delivery/',
    loadFilters: false,
    requestFilters: false,
    sortTypes: ['-created', 'price_delivery', '-price_delivery'],
    sort: '-created',
    mode: 'server',
    state: {
      firstPage: 1,
      pageSize: 50,
      order: 0,
    },
    model: app.CartItem,
    parseRecords: function (response) {
      this._cart = response._cart;
      return response.items || [];
    },
    parseState: function (response) {
      this.state.totalPages = response._meta.pageCount;
      return {
        totalRecords: response._meta.totalCount,
        totalPages: response._meta.pageCount,
      };
    },
    setQueryParams: function () {
      this.queryParams = {
        sort: function () {
          return this.sort;
        }.bind(this),
      };
    },

    /**
     * @inheritDoc
     * Переопределили, потому что родительский sync не возвращает xhr.
     * @return {jqXHR} jQuery XMLHttpRequest
     */
    sync: function () {
      // Если прыдыдущий запрос не завершился, отменяем его.
      if (this.lastRequest && this.lastRequest.status !== 200) {
        this.lastRequest.abort();
      }
      return this.lastRequest = Backbone.PageableCollection.prototype.sync.apply(this, arguments);
    },

    /**
     * Определяет, есть ли подробная информаци о доставке.
     * @return {boolean} Булево значение, определяющее, можно ли открыть попап с расчетом доставки.
     */
    hasExtraInfo: function () {
      var deliveryTerms = this._cart || {};
      return Boolean(deliveryTerms.delivery_markup || deliveryTerms.delivery_subtotal);
    },
  });
})(jQuery);

}.call(window));